import { Options, merge } from 'highcharts';
import { baseChartOptions } from './base-chart.options';

/**
 * Configuration for Bar chart type
 * Extends the base chart configuration
 */
export const barChartOptions: Options = merge({}, baseChartOptions, {
    chart: {
        type: 'bar'
    },
    plotOptions: {
        bar: {
            borderRadius: 2,
            borderWidth: 0,
            pointPadding: 0.1,
            groupPadding: 0.2,
            states: {
                hover: {
                    brightness: 0.1
                }
            },
            dataLabels: {
                enabled: false
            }
        }
    },
    legend: {
        enabled: true
    },
    tooltip: {
        headerFormat: '<span style="font-size: 10px">{point.key}</span><br/>',
        pointFormat: '<span style="color:{point.color}">\u25CF</span> {series.name}: <b>{point.y}</b><br/>'
    },
    // For horizontal bar charts, we often want to invert the axes
    xAxis: {
        gridLineWidth: 0
    },
    yAxis: {
        gridLineWidth: 0,
        title: {
            text: ''
        }
    }
} as Options);
